<template>
  <div id="listagem-cnpj">
    <loading
      :active.sync="carregando"
      :is-full-page="true"
    ></loading>

    <div
      v-if="items.length > 0"
      id="tabela-listagem-cnpj-container"
      class="my-3"
      :class="{ 'tabela-listagem-cnpj-desabilitada': tabelaEstaDesabilitada }"
    >
      <tabelaListagemCNPJHeader
        :search="search"
        :disabled="tabelaEstaDesabilitada"
        @porPaginaAtualizado="itensPorPagina = $event"
        @searchAtualizado="search = $event"
      />
  
      <b-table
        responsive
        striped
        hover
        show-empty
        stacked="md"
        primary-key="cnpj"
        select-mode="multi"
        id="tabela-listagem-cnpj"
        summary="Tabela Listagem CNPJ"
  
        :fields="headers"
        :items="itemsFiltrados"
        :current-page="paginaAtual"
        :per-page="itensPorPagina"
        :sort-by.sync="ordenacaoTipo"
        :sort-direction="ordenacaoDirecao"
        :sort-desc.sync="ordenacaoDirecaoDesc"
        :sort-compare="ordenarValores"
        :tbody-tr-class="(item) => (item && item.selecionado ? 'tr-selecionada' : '')"
      >
        <template v-slot:empty="">
          <div class="text-center py-5 my-5">
            <h5 class="font-weight-bold mb-2">Nenhum resultado encontrado.</h5>
            <p class="mb-2">Não localizamos associação do CPF com o CNPJ na base consultada.</p>
            <p class="mb-3">Você pode tentar recarregar os dados no botão abaixo:</p>
            <div class="d-flex justify-content-center">
              <b-button
                @click="handleRecarregarDados()"
              >
                Recarregar dados da base
              </b-button>
            </div>
          </div>
        </template>
  
        <template v-slot:cell(selecionado)="{ item, field: { key } }">
          <b-radio
            v-model="item[key]"
            :value="true"
            :name="item.cnpj_limpo"
            :id="item.cnpj_limpo"
            :disabled="tabelaEstaDesabilitada"
            @change="alternarCnpj(item.cnpj_limpo)"
          />
        </template>
      </b-table>
  
      <div 
        v-if="mostrarBuscaDiretaRodape" 
        class="text-center pt-2 pb-1"
      >
        <p class="font-weight-bold mb-2">O CNPJ que você está procurando não está na lista?</p>
        <p class="mb-3">Você pode tentar recarregar os dados no botão abaixo:</p>
        <div class="d-flex justify-content-center">
          <b-button
            @click="handleRecarregarDados()"
          >
            Recarregar dados da base
          </b-button>
        </div>
      </div>
  
      <tabelaListagemCNPJFooter
        :itensPorPagina="itensPorPagina"
        :totalItens="itemsFiltrados.length"
        :paginaAtual="paginaAtual"
        :disabled="tabelaEstaDesabilitada"
        @paginaAtualizada="paginaAtual = $event"
      />
    </div>
  </div>
</template>
  
<script>
import tabelaListagemCNPJHeader from './tabelaListagemCNPJHeader.vue';
import tabelaListagemCNPJFooter from './tabelaListagemCNPJFooter.vue';
import montaCNPJSRelacionadosGovBr from '../../composables/montaCNPJSRelacionadosGovBr';
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "tabelaListagemCNPJ",
  components: {
    tabelaListagemCNPJHeader,
    tabelaListagemCNPJFooter,
    loading,
  },
  props: {
    rows: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    forcaLimparCampos: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ordenacaoDirecaoDesc: {
      get() {
        return this.ordenacaoDirecao === 'desc';
      },
      set(value) {
        this.ordenacaoDirecao = value ? 'desc' : 'asc';
      },
    },
    itemsFiltrados() {
      if (!this.search) {
        return this.items;
      }
      const search = this.search? this.search.trim().toLowerCase(): '';
      const searchSanitizado = search.replace(/[^a-zA-Z0-9]+/g, '');
      return this.items.filter((item) => {
        return (item.nome && item.nome.toLowerCase().includes(search)) ||
               (item.cnpj_limpo && item.cnpj_limpo.toLowerCase().includes(searchSanitizado)) ||
               (item.cnpj && item.cnpj.toLowerCase().includes(search));
      }).map((item) => {
        return {
          ...item,
          papel: item.papel || '-',
          selecionado: this.cnpjSelecionado === item.cnpj_limpo,
        };
      });
    },
    mostrarBuscaDiretaRodape() {
      // Não mostrar se não houver itens filtrados
      if (this.itemsFiltrados.length === 0) {
        return false;
      }
      // Mostrar apenas quando estiver na última página
      const totalPaginas = Math.ceil(this.itemsFiltrados.length / this.itensPorPagina);
      const estaNaUltimaPagina = this.paginaAtual === totalPaginas && totalPaginas > 0;
      return estaNaUltimaPagina;
    },
  },
  data() {
    return {
      items: [],
      headers: [
        { key: 'selecionado', label: '', sortable: false },
        { key: 'cnpj', label: 'CNPJ', sortable: true },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'papel', label: 'Papel', sortable: true },
      ],
      search: "",
      paginaAtual: 1,
      itensPorPagina: 5,
      cnpjSelecionado: null,
      ordenacaoTipo: 'papel',
      ordenacaoDirecao: 'desc',
      ordenacaoDecrescente: true,
      tabelaEstaDesabilitada: false,
      cnpjBuscaDireta: "",
      cnpjBuscaDiretaRodape: "",
      carregando: true,
      cnpjsJaForamRecarregados: false,
    };
  },
  watch: {
    'disabled': {
      immediate: true,
      handler(newValue, oldValue) {
        this.tabelaEstaDesabilitada = newValue;
        // se a tabela estiver desabilitada, desmarcar todos os itens
        if (!newValue && oldValue) {
          this.search = "";
          this.cnpjSelecionado = null;
          this.items = this.items.map((item) => {
            item.selecionado = false;
            return item;
          });
        }
      },
    },
    'forcaLimparCampos': {
      immediate: true,
      handler() {
        // limpa os campos quando forcaLimparCampos mudar
        this.search = "";
        this.cnpjSelecionado = null;
        this.items = this.items.map((item) => {
          item.selecionado = false;
          return item;
        });
      },
    },
    'rows': {
      immediate: true,
      async handler(val) {
        this.items = val? val.map((item) => {
          return {
            ...item,
            cnpj: item.cnpj.replace(/\D/g, ""),
            papel: item.papel || '-',
            selecionado: false,
          };
        }): [];
        this.search = "";
        const atributosUsuario = this.$store.getters.keycloak.userInfo.attributes || null;
        await this.buscarCNPJSRelacionados(atributosUsuario);
        this.carregando = false;
      },
    },
    async paginaAtual() {
      if (this.cnpjsJaForamRecarregados) {
        return;
      }
      await this.recarregarCnpjsRelacionados();
    },
  },
  methods: {
    handleRecarregarDados() {
      // limpa o filtro de busca
      this.search = "";
      this.paginaAtual = 1;
      this.recarregarCnpjsRelacionados();
    },
    async recarregarCnpjsRelacionados() {
      this.carregando = true;
      const atributosUsuario = this.$store.getters.keycloak.userInfo.attributes || null;
      await this.buscarCNPJSRelacionados(atributosUsuario);
      this.carregando = false;
    },
    /**
     * Busca os CNPJs relacionados ao CPF do usuário logado via Gov.br
     * @param store - opcional, passar uma store diferente da atual
     */
    async buscarCNPJSRelacionados(atributosUsuario=null) {
      /** [{cnpj, razao_social, data_inicial, papel, data_final}, ...] */
      let cnpjRelacionados = atributosUsuario ? 
        montaCNPJSRelacionadosGovBr(atributosUsuario) :
        [];

      // Quando não houver CNPJs relacionados vindos do Gov,
      // aguardar alguns instantes e buscar novamente
      if (cnpjRelacionados.length === 0) {
        cnpjRelacionados = await this.recarregaListaDeCNPJsRelacionados(cnpjRelacionados);
      }

      cnpjRelacionados = cnpjRelacionados.map((valor) => {
        return {
          cnpj: valor.cnpj,
          cnpj_limpo: valor.cnpj.replace(/\D/g, ""),
          nome: valor.razao_social,
          papel: valor.papel.replace(/_/g, ' '),
          selecionado: false,
        };
      });

      // Remove itens que já estão na lista de relacionados
      this.items = this.items.filter(item => {
        return !cnpjRelacionados.some(cnpj => cnpj.cnpj_limpo === item.cnpj_limpo);
      });
      this.items = [...cnpjRelacionados, ...this.items];
      this.items.sort((a, b) => {
        return this.ordenarValores(a, b, this.ordenacaoTipo);
      });
      this.items = this.items.map((item) => {
        return {
          ...item,
          selecionado: this.cnpjSelecionado === item.cnpj_limpo,
        };
      });
   
      const lista = this.items;
        this.$emit('update:listaCnpjRelacionados', {
           lista
        });       
    },
    promessaAguardaSegundos(segundos) {
      return new Promise((resolve) => setTimeout(resolve, segundos * 1000));
    },
    async recarregaListaDeCNPJsRelacionados(cnpjsRelacionados = []) {
      if (this.cnpjsJaForamRecarregados) {
        return cnpjsRelacionados;
      }
      if (cnpjsRelacionados && cnpjsRelacionados.length > 0) {
        return cnpjsRelacionados;
      }
      await this.promessaAguardaSegundos(2);
      let resultado = await this.$store.getters.keycloak.loadUserInfo();
      this.cnpjsJaForamRecarregados = true;
      if (!resultado || !resultado.attributes) {
        return [];
      }
      return montaCNPJSRelacionadosGovBr(resultado.attributes);
    },
    ordenarValores(a, b, column) {
      return a[column] > b[column] ? 1 : -1;
    },
    alternarCnpj(cnpj) {
      this.cnpjSelecionado = cnpj;      
      this.items = this.items.map((item) => {
        item.selecionado = item.cnpj_limpo === cnpj;
        return item;
      });
      const itemSelecionado = this.items.find((item) => item.cnpj_limpo === cnpj);
      const dadosEstabelecimentoSelecionado = {};  
      dadosEstabelecimentoSelecionado.codigoNacional = itemSelecionado.cnpj_limpo;
      dadosEstabelecimentoSelecionado.razaoSocial = itemSelecionado.nome;
      dadosEstabelecimentoSelecionado.tipoPapel =   itemSelecionado.papel;
      if (itemSelecionado) {
        this.$emit('update:selecionado', {
          dadosEstabelecimentoSelecionado
        });      
      }
    },
    emitirBuscaDireta() {
      if (this.cnpjBuscaDireta) {
        this.$emit('busca-direta', this.cnpjBuscaDireta);
        this.cnpjBuscaDireta = "";
      }
    },
    emitirBuscaDiretaRodape() {
      if (this.cnpjBuscaDiretaRodape) {
        this.$emit('busca-direta', this.cnpjBuscaDiretaRodape);
        this.cnpjBuscaDiretaRodape = "";
      }
    },
  },
};
</script>
  
<style>
#listagem-cnpj {
  min-height: 435px;
}
#tabela-listagem-cnpj-container .table-responsive {
  border: 1px solid #f2f2f2;
}
.tabela-listagem-cnpj-desabilitada {
  pointer-events: none;
  opacity: 0.8;
}
/** Quando estiver no desktop, limitar o width da primeira e segunda colunas  */
@media screen and (min-width: 769px) {
  #tabela-listagem-cnpj thead th:nth-child(1),
  #tabela-listagem-cnpj tbody td:nth-child(1) {
    width: 55px;
  }
  #tabela-listagem-cnpj thead th:nth-child(2),
  #tabela-listagem-cnpj tbody td:nth-child(2) {
    width: 180px;
  }
  #tabela-listagem-cnpj thead th:nth-child(3),
  #tabela-listagem-cnpj tbody td:nth-child(3) {
    width: 450px;
  }
}
#tabela-listagem-cnpj tbody tr.tr-selecionada {
  background-color: #d5d5d5;
}
</style>